{
  "appName": "VynaEMR",
  "appTagline": "Rekod Perubatan Elektronik Tertumpu APAC",
  "developedByLabel": "Dibangunkan oleh",
  "loading": "Memuatkan...",
  "save": "Simpan",
  "cancel": "Batal",
  "delete": "Padam",
  "edit": "Sunting",
  "create": "Cipta",
  "search": "Cari",
  "filter": "Tapis",
  "actions": "Tindakan",
  "confirm": "Sahkan",
  "back": "Kembali",
  "next": "Seterusnya",
  "previous": "Sebelumnya",
  "submit": "Hantar",
  "reset": "Set Semula",
  "close": "Tutup",
  "yes": "Ya",
  "no": "Tidak",
  "ok": "OK",
  "error": "Ralat",
  "success": "Berjaya",
  "warning": "Amaran",
  "info": "Maklumat",
  "validation": {
    "required": "Ruangan ini wajib diisi",
    "invalidEmail": "Alamat e-mel tidak sah",
    "invalidPhone": "Nombor telefon tidak sah",
    "invalidDate": "Tarikh tidak sah",
    "minLength": "Minimum {{min}} aksara diperlukan",
    "maxLength": "Maksimum {{max}} aksara dibenarkan",
    "passwordMismatch": "Kata laluan tidak sepadan"
  },
  "form": {
    "fieldRequired": "{{field}} wajib diisi",
    "selectOption": "Sila pilih satu pilihan",
    "discardConfirm": "Buang perubahan yang belum disimpan?",
    "unsavedChanges": "Anda mempunyai perubahan yang belum disimpan",
    "mustBeNonNegativeInteger": "{{field}} mesti nombor bulat (0 atau lebih)",
    "mustBeNonNegativeNumber": "{{field}} mesti nombor (0 atau lebih)"
  },
  "unsavedChanges": {
    "title": "Perubahan Belum Disimpan",
    "body": "Anda mempunyai perubahan yang belum disimpan. Adakah anda pasti mahu meninggalkan halaman ini? Perubahan akan hilang.",
    "stay": "Kekal",
    "leave": "Tinggalkan"
  },
  "messages": {
    "saveSuccess": "Perubahan berjaya disimpan",
    "saveError": "Gagal menyimpan perubahan",
    "deleteConfirm": "Adakah anda pasti mahu memadamkan item ini?",
    "deleteSuccess": "Item berjaya dipadam",
    "deleteError": "Gagal memadamkan item",
    "networkError": "Ralat rangkaian. Sila semak sambungan anda.",
    "serverError": "Ralat pelayan. Sila cuba lagi kemudian.",
    "unauthorized": "Anda tidak dibenarkan untuk melakukan tindakan ini."
  },
  "dateFormat": {
    "short": "DD/MM/YYYY",
    "long": "D MMMM YYYY",
    "withTime": "DD/MM/YYYY HH:mm",
    "timeOnly": "HH:mm"
  },
  "demo": {
    "warning": "Ini ialah demo VynaEMR — jangan masukkan maklumat pesakit sebenar (PHI)."
  },
  "network": {
    "offline": "Anda di luar talian. Data klinikal mungkin tidak disimpan."
  },
  "permissionDenied": {
    "title": "Akses Dinafikan",
    "body": "Anda tidak mempunyai kebenaran untuk {{action}}.",
    "genericBody": "Anda tidak mempunyai kebenaran untuk melihat sumber ini.",
    "requiredPermission": "Kebenaran diperlukan: {{name}}",
    "contactAdmin": "Jika anda percaya ini adalah ralat, sila hubungi pentadbir sistem anda.",
    "requiresPermissionCode": "Memerlukan kebenaran: {{code}}",
    "requiresLabel": "Memerlukan {{label}}",
    "requiresLabelWithRoles": "Memerlukan {{label}} (dipegang oleh: {{roles}})",
    "insufficient": "Kebenaran tidak mencukupi"
  },
  "skipToContent": "Langkau ke kandungan",
  "openMenu": "Buka menu",
  "topBar": {
    "searchPlaceholder": "Cari pesakit (MRN, nama, ID)...",
    "recentPatients": "Pesakit Terkini",
    "searching": "Mencari...",
    "noPatientsFound": "Tiada pesakit dijumpai. Tekan Enter untuk mencari.",
    "notifications": "Pemberitahuan",
    "selectFacility": "Pilih kemudahan",
    "allFacilities": "Semua Kemudahan",
    "facilityLabel": "Kemudahan {{id}}",
    "activeDepartment": "Bertugas di",
    "selectDepartment": "Pilih jabatan bertugas",
    "noDepartmentSelected": "Pilih jabatan",
    "departmentLabel": "Jabatan {{id}}",
    "departmentSwitchFailed": "Gagal menukar"
  },
  "theme": {
    "toggle": "Tukar tema",
    "light": "Cerah",
    "dark": "Gelap",
    "system": "Sistem",
    "current": "Tema: {{name}}"
  },
  "appVersionLabel": "VynaEMR v{{version}}",
  "footerCopyright": "© {{year}}",
  "footerHealthOperational": "Beroperasi",
  "footerHealthIssue": "Masalah sambungan",
  "dobLabel": "Tarikh Lahir {{date}}",
  "pagination": {
    "previous": "Sebelumnya",
    "next": "Seterusnya",
    "pageOf": "Halaman {{current}} daripada {{total}}",
    "showing": "Memaparkan {{from}} hingga {{to}} daripada {{total}}",
    "loadMore": "Muat lagi"
  },
  "table": {
    "empty": "Tiada data",
    "loading": "Memuatkan..."
  },
  "cdsAlert": {
    "severity": {
      "info": "Maklumat",
      "warning": "Amaran",
      "critical": "Kritikal"
    },
    "overridden": "Diatasi",
    "acknowledged": "Diakui",
    "justificationPlaceholder": "Masukkan sebab justifikasi...",
    "submit": "Hantar",
    "acknowledge": "Akui",
    "override": "Atasi",
    "regionAria": "Amaran sokongan keputusan klinikal (CDS)",
    "acknowledgeFailed": "Tidak dapat merekod pengakuan — ia tidak disimpan. Sila cuba lagi.",
    "overrideFailed": "Tidak dapat merekod pengatasan — ia tidak disimpan. Sila cuba lagi.",
    "addressedCount_one": "{{count}} ditangani",
    "addressedCount_other": "{{count}} ditangani"
  },
  "components": {
    "printButton": {
      "defaultLabel": "Cetak"
    },
    "codeSearch": {
      "searchPlaceholder": "Cari kod...",
      "clearAriaLabel": "Kosongkan pilihan",
      "noCodesFound": "Tiada kod dijumpai"
    },
    "demographicPicker": {
      "addPlaceholder": "Tambah…",
      "loading": "Memuatkan…",
      "noneRecorded": "Tiada rekod",
      "removeAriaLabel": "Buang {{value}}",
      "unavailable": "Senarai nilai tidak tersedia",
      "unavailableHint": "Senarai nilai tidak dapat dimuatkan. Nilai sedia ada kekal tidak berubah dan akan tetap disimpan.",
      "uncodedBadge": "tanpa kod",
      "uncodedTitle": "Direkodkan sebelum nilai berkod wujud. Ia boleh dibuang, tetapi tidak boleh ditambah semula."
    }
  },
  "pages": {
    "accessDenied": {
      "title": "Akses Dinafikan",
      "httpStatus": "HTTP 403",
      "body": "Anda tidak mempunyai kebenaran untuk melihat halaman ini.",
      "attemptedLabel": "Cuba mengakses:",
      "requiredPermissionLabel": "Kebenaran yang diperlukan:",
      "typicallyHeldByLabel": "Biasanya dipegang oleh:",
      "signedInAs": "Log masuk sebagai",
      "contactAdminHelp": "Jika anda percaya ini adalah ralat, sila hubungi pentadbir sistem atau ketua jabatan untuk memohon peranan yang diperlukan.",
      "goBack": "Kembali",
      "dashboard": "Papan Pemuka",
      "contact": "Hubungi"
    },
    "notificationInbox": {
      "title": "Notifikasi",
      "markAllRead": "Tandakan Semua Sebagai Telah Dibaca",
      "loading": "Memuatkan notifikasi…",
      "errorState": "Gagal memuatkan notifikasi.",
      "emptyState": "Tiada notifikasi ditemui.",
      "ariaFilterStatus": "Tapis mengikut status",
      "ariaFilterPriority": "Tapis mengikut keutamaan",
      "ariaFilterType": "Tapis mengikut jenis",
      "filterStatus": {
        "all": "Semua",
        "unread": "Belum Dibaca",
        "read": "Telah Dibaca"
      },
      "filterPriority": {
        "allLabel": "Semua Keutamaan",
        "critical": "Kritikal",
        "high": "Tinggi",
        "normal": "Biasa",
        "low": "Rendah"
      },
      "filterType": {
        "allLabel": "Semua Jenis"
      },
      "notificationType": {
        "criticalResult": "Keputusan Kritikal",
        "orderUpdate": "Kemas Kini Pesanan",
        "appointmentReminder": "Peringatan Temu Janji",
        "systemAlert": "Amaran Sistem",
        "cdsAlert": "Amaran Sokongan Keputusan Klinikal",
        "result": "Keputusan Ujian",
        "handoffAssigned": "Serah terima"
      },
      "toasts": {
        "allMarkedRead": "Semua notifikasi telah ditandakan sebagai dibaca",
        "markAllReadFailed": "Gagal menandakan semua notifikasi sebagai dibaca",
        "markReadFailed": "Gagal menandakan notifikasi sebagai dibaca"
      }
    },
    "entityResolver": {
      "invalidId": "Pautan tidak sah.",
      "notFound": "Tidak dijumpai, atau anda tiada akses kepadanya."
    }
  },
  "license": {
    "evalBanner": "Evaluation license: {{count}} days left.",
    "graceBanner": "License issue: service continues for {{count}} more hours.",
    "expiringBanner": "License expires soon: {{count}} days left. Renew now to avoid service refusal.",
    "saasUnkeyedBanner": "Organization license not installed. Premium modules are open during rollout.",
    "saasUnverifiableBanner": "Organization license cannot be verified. Premium modules are open; contact support.",
    "expiredBanner": "License expired. Requests are being refused.",
    "invalidBanner": "License invalid. Requests are being refused.",
    "viewLicense": "View license"
  },
  "wsDown": {
    "title": "Kemas kini langsung tidak tersedia",
    "body": "Keputusan dan amaran baharu tidak akan tiba secara automatik sehingga sambungan dipulihkan.",
    "authBody": "Sesi anda telah tamat. Log masuk semula untuk memulihkan kemas kini langsung.",
    "retry": "Cuba lagi",
    "login": "Log masuk"
  }
}
